






















































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { DxDataGrid, DxColumn } from 'devextreme-vue/data-grid';
import { DataSource } from '@/types';
import { ConsumptionsPageArgs } from './types';
import { TableConfig, defaultTableConfig, columnTemplates } from '@/core/components/table';
import { CONTRACTS, WindowsServiceContract } from '@/core/contracts';
import { Inject } from '@/core/helpers/vue-inversify-decorator';

@Component({
    components: {
        DxDataGrid,
        DxColumn,
    },
})
export default class ConsumptionsSubPacksTable extends Vue {
    @Prop({ type: String, required: true }) public tableKey!: string;
    @Prop({ type: [Array, Object], required: true })
    public dataSource!: DataSource;

    @Inject(CONTRACTS.WindowsService)
    private _windowsService?: WindowsServiceContract;

    public get defaultTableConfig(): Partial<TableConfig> {
        return defaultTableConfig(this);
    }

    public get columnTemplates() {
        return columnTemplates;
    }

    public onFocusedRowChanged(e: any) {
        const subPackId = e.row.data.id + 1;
        const packId = e.row.data.packId;
        this._windowsService!
            .update('consumptions-routes-page', {
                packId,
                detailId: subPackId
            } as ConsumptionsPageArgs);
    }
}
